// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"8e0cd652","172":"e90cd7a4","415":"d420c071","423":"fa8b83d4","460":"5d375c76","520":"df322d8f","778":"48802584"}[chunkId] + ".chunk.js";
};